/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-11-23 15:10:43
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from "react";
import { BsyUtils } from "../../../utils/Utils";
import { BsyWidget } from "../../BsyWidget";

import "./index.css";

export class BsyFilterBtn extends BsyWidget {
  DEFAULT_SIZE = {
    defaultSizeX: 6,
    defaultSizeY: 3,
    minSizeX: 4,
    minSizeY: 2,
  };

  constructor(props) {
    super({
      baseCls: "bsy-dash-button",
      onClick: null,
      text: React.language("filter"),
      minRow: 10,
    });
    this.state = {
      height: 0
    }
    this.element = React.createRef();
  }

  getContext = (e) => {
    this.dashText = e;
  };

  //block-content

  componentDidMount() {
    if (this.element.current) {
      let r = BsyUtils.closestClass(this.element.current, "block-content");
      if (r) {
        let h = r.offsetHeight;
        // this.element.current.style.height = h + 'px';
        // this.element.current.style.lineHeight = h + 'px';
      }
    }
    var ret = BsyUtils.closestClass(this.element.current, 'filter_btn');
    if (ret) {
      this.setState({
        height: window.$(ret).height() + 5
      })
    }
  }

  onClick = () => {
    BsyUtils.applyFunc(this, this.props.onClick, [], !1);
  };
  onClear = () => {
    BsyUtils.applyFunc(this, this.props.onClear, [], !1);
  }
  render() {
    const { text } = this.options;
    return (
      <div className="t-btn--button-filter-conment t-button-comment">
        <div className={"bsy-dash-button"} ref={this.element} onClick={this.onClick}>
          {text}
        </div>
        <div className="t-line"></div>
        <div className="t-up-dowm">
          <div className="t-up-dowm-height" style={{height:"120%"}}>
            <i className="icon-down1"></i>
            <div className="t-down-clear" style={{ top: this.state.height + "px" }} onClick={this.onClear}>{React.language("dash.clear.filter")}</div>
          </div>
         
        </div>
      </div>
    );
  }
}
